import { render, staticRenderFns } from "./platttask-add.vue?vue&type=template&id=e039d530&scoped=true&"
import script from "./platttask-add.vue?vue&type=script&lang=js&"
export * from "./platttask-add.vue?vue&type=script&lang=js&"
import style0 from "./platttask-add.vue?vue&type=style&index=0&id=e039d530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e039d530",
  null
  
)

export default component.exports